import { useQuery } from "@tanstack/react-query";
// import { getAllBranch } from "../../services/admin/branch-service";
import { getAllBranch } from "../../services/admin/branch-service";

export const useGetAllBranches = () => {
  return useQuery({
    queryKey: ["getBranch"],
    queryFn: async () => {
      const response = await getAllBranch();

      if (!response.success) {
        throw new Error(response.message || "Failed to fetch roles");
      }

      return response?.data?.data || [];
    },
    staleTime: 1000 * 60 * 5,
 
  });
};
